exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dragDrop[data-v-20448c06]{\r\n  height: 200px;\r\n  border-radius: 6px;\r\n  cursor: pointer;\n}\n.dragDropRest[data-v-20448c06]{\r\n  background-color:white ;\r\n  border: rgba(72, 21, 127, 0.7) dotted 2px;\n}\n.dragDropActive[data-v-20448c06]{\r\n  background-color: rgba(72, 21, 127, 0.2);\r\n  border: rgba(72, 21, 127, 0.7) dotted 2px;\n}\n.spinner-container[data-v-20448c06]{\r\n  top: 50%;\r\n  left: 50%;\r\n  position: relative\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-20448c06","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/requests/creationPages/OCRScanTemplate.vue
// module id = 1549
// module chunks = 2